module.exports = __webpack_public_path__ + "img/مدرن .a465d257.jpg";